// Metadatos de formato (relación de aspecto) para los controles del generador.
// "auto" no tiene relación fija: la decide el modelo/proveedor.
export const STANDARD_FORMATS = ["auto", "1:1", "4:3", "3:4", "3:2", "2:3", "4:5", "16:9", "9:16"];
export const EXTENDED_FORMATS = ["21:9", "4:1", "1:4", "8:1", "1:8"];

export const FORMAT_RATIO = {
  auto: null,
  "1:1": 1,
  "4:3": 4 / 3,
  "3:4": 3 / 4,
  "3:2": 3 / 2,
  "2:3": 2 / 3,
  "4:5": 4 / 5,
  "16:9": 16 / 9,
  "9:16": 9 / 16,
  "21:9": 21 / 9,
  "4:1": 4,
  "1:4": 1 / 4,
  "8:1": 8,
  "1:8": 1 / 8,
};

export const IMAGE_RESOLUTIONS = ["0.5K", "1K", "1.5K", "2K", "3K", "4K"];
export const VIDEO_RESOLUTIONS = ["480p", "540p", "720p", "1080p", "4K"];
export const QUANTITIES = [1, 2, 4];

export const closestFormat = (ratio) => {
  if (!ratio) return "auto";
  let best = "auto", bestDiff = Infinity;
  Object.entries(FORMAT_RATIO).forEach(([key, r]) => {
    if (!r) return;
    const diff = Math.abs(r - ratio);
    if (diff < bestDiff) { bestDiff = diff; best = key; }
  });
  return best;
};

export const formatMatchesAsset = (format, asset) => {
  if (!asset?.width || !asset?.height || format === "auto") return true;
  const ratio = FORMAT_RATIO[format];
  if (!ratio) return true;
  const assetRatio = asset.width / asset.height;
  return Math.abs(assetRatio - ratio) / ratio < 0.08;
};
